import Vue from 'vue';
import Vuex from 'vuex';
//import router from '../router';
import axios from 'axios';
import strapi from '../strapi';

Vue.use(Vuex);

const API_URL =
  process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_STRAPI_API_URL
    : 'http://localhost:1338';

export default new Vuex.Store({
  state: {
    data: null,
    courseCategories: null,
    usersCourses: null,
    thisCourse: null,
    pastPath: null,
    isButtonUpdated: false,
    uploadResponse: null,
    createPDFResponse: null,
    selectedMod: [],
    // user: {
    //   email: null,
    //   username: null,
    //   role: null,
    // },
    // token: null,
  },
  getters: {
    user(state) {
      return state.user;
    },
    courseCategories: (state) => (id) => {
      return state.courseCategories.filter((course) => course.id === id);
    },
    getSelectedMedia: (state) => state.selectedMod,
  },
  mutations: {
    storeCourseCategories(state, data) {
      console.log('storing courseCategories...');
      state.courseCategories = data;
    },
    storeUsersCourses(state, data) {
      console.log('storing usersCourses...');
      console.log('usersCourses:', data);
      state.usersCourses = data;
    },
    storeUser(state, data) {
      console.log('storing user...');
      state.user = data.userObject;
      state.token = data.token;
    },
    storePastPath(state, path) {
      console.log('storing pastPath...');
      state.pastPath = path;
    },
    updateButtonStatus(state, isUpdated) {
      state.isButtonUpdated = isUpdated;
    },
    setUploadResponse(state, response) {
      state.uploadResponse = response;
    },
    setCreatePDFResponse(state, response) {
      state.createPDFResponse = response;
    },
    REMOVE_MODULE(state, moduleId) {
      state.modules = state.modules.filter((module) => module.id !== moduleId);
    },
    setSelectedMod(state, mod) {
      state.selectedMod = mod;
    },
  },
  actions: {
    setPastPath({ commit }, path) {
      commit('storePastPath', path);
    },

    updateSelectedMod({ commit }, mod) {
      commit('setSelectedMod', mod);
    },

    async setData({ commit }) {
      console.log('setData store triggered');
      const user = localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user'))
        : null;

      const token = localStorage.getItem('token')
        ? localStorage.getItem('token')
        : null;

      const courses = await strapi.getAllCourses(token);
      const existingCategories = [];
      const courseCategories = [];

      courses.forEach((course) => {
        const courseCategory = course.course_category.name;

        let i = 0;
        let exists = false;
        while (!exists && i < existingCategories.length) {
          const category = existingCategories[i];
          if (category == courseCategory) {
            exists = true;
          }
          i++;
        }

        if (!exists) {
          existingCategories.push(courseCategory);

          let coursesOfCategory = [];
          courses.forEach((course) => {
            if (courseCategory == course.course_category.name) {
              coursesOfCategory.push(course);
            }
          });

          courseCategories.push({
            name: courseCategory,
            courses: coursesOfCategory,
          });
        }
      });
      commit('storeCourseCategories', courseCategories);

      // get "myCourses"
      // if instructor, these will appear in InstructorCourses page.
      // if student, these will appear in MyCourses page.

      if (
        (user && user.role.name > 0) ||
        user.user_permissions.some((p) => p.key === 'super_admin')
      ) {
        const usersCourses = await strapi.getUsersCourses();

        commit('storeUsersCourses', usersCourses);
      }

      return courseCategories;
    },
    async authenticateUser({ commit }, credentials) {
      try {
        //console.log('cre', credentials.email);
        const res = await strapi.authenticateUser(credentials);

        commit('storeUser', res);

        //router.go('/');

        return res;
      } catch (error) {
        switch (error.code) {
          case 'auth/user-not-found':
            alert('user not found');
            break;
          case 'auth/wrong-password':
            alert('Wrong password');
            break;
          default:
            alert('Error');
            console.log('error:', error);
        }
      }
    },
    fetchUser({ commit }) {
      commit('storeUser');
    },
    async update({ commit }, course) {
      // for (let i = 0; i < course.sections.length; i++) {
      //   const section = course.sections[i];

      //   for (let j = 0; j < section.modules.length; j++) {
      //     const mod = section.modules[j];

      //     for (let k = 0; k < mod.media.length; k++) {
      //       const media = mod.media[k];

      //       if (!media.url) {
      //         // create new media
      //         const res = await strapi.newMedia(media);
      //         console.log("new media in library", res);
      //       }
      //     }
      //   }
      // }
      console.log('backend update commit course', course);

      const updatedCourse = await strapi.update(course);
      console.log('updatedCourse in store', updatedCourse);

      console.log(commit);
    },
    async delete({ commit }, course) {
      const createdCourse = await strapi.delete(course);
      console.log('deletedCourse in store', createdCourse);

      console.log(commit);
    },
    async create({ commit }, course) {
      const createdCourse = await strapi.create(course);
      console.log('createdCourse in store', createdCourse);

      console.log(commit);
    },
    async uploadPDF({ commit }, formData) {
      try {
        console.log('store uploadPDF ', formData);
        const uploadResponse = await axios.post(
          `${API_URL}/newMedia`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        // Store the response in the state
        commit('setUploadResponse', uploadResponse.data);
        // Return the upload response for further use
        return uploadResponse.data;
      } catch (error) {
        console.error(
          'Error uploading file:',
          error.response ? error.response.data : error
        );
        throw error;
      }
    },
    async createPDF({ commit }, fileId) {
      try {
        const newPDF = {
          File: fileId,
        };

        // Create an entry in PdfUploads collection with the uploaded file ID
        const createPDFResponse = await axios.post(
          `${API_URL}/pdf-uploads`,
          newPDF,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        // Commit the create PDF response to the state
        commit('setCreatePDFResponse', createPDFResponse.data);

        // Return the create PDF response for further use
        return createPDFResponse.data;
      } catch (error) {
        console.error(
          'Error creating PDF entry:',
          error.response ? error.response.data : error
        );
        throw error;
      }
    },
    async deleteModule({ commit }, moduleId) {
      try {
        const token = localStorage.getItem('token'); // Adjust based on how you store your JWT
        //const API_URL = 'http://localhost:1338'; // Adjust based on your Strapi server URL

        const response = await axios.delete(`${API_URL}/modules/${moduleId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          console.log('Module deleted successfully', response.data);
          // Optionally, commit a mutation to update your state
          commit('REMOVE_MODULE', moduleId);
        } else {
          console.error('Failed to delete module', response);
        }
      } catch (error) {
        console.error('Error deleting module', error);
      }
    },
  },
  modules: {},
});
